<template>
    <div>
        <!-- store location modal -->
        <b-modal :id="modalStore.id"
                 modal-class="modal-store"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close" @click="hideModalStore()"></div>
                    <!-- <p>STORE</p> -->
                </div>
                <div class="modal-base-body">
                    <div class="modal-base-body-inner">

                        <div class="store-img-wrapper" >
                            <img v-if="!modalStore.image_url" :src="getImageDefault()"/>
                            <img v-else :src="modalStore.image_url" />
                        </div>
                        <!-- <img src="@/assets/img/04-store/image-defalt-store.png" /> -->
                        <div class="body-item-inner">
                            <div class="store-wrapper col-12">
                                <span class="pipe col-1">|</span>
                                <div class="store-name col-7">{{modalStore.title}}</div>
                                 <div class="distance col-4 px-0">{{getBranceDistance(modalStore.distance)}}
                                    <span class="ml-2">{{lbl.location.km}}</span>
                                </div>
                            </div>
                            <!-- <div class="store-wrapper">
                                <span class="pipe">|</span>
                                <div class="store-name">{{modalStore.title}}</div>
                                <div class="distance">{{getBranceDistance(modalStore.distance)}}
                                    <span class="ml-2">{{lbl.location.km}}</span>
                                </div>
                            </div> -->

                            <!-- <h5><div>|</div><div>{{modalStore.title}}</div><div class="distance">{{getBranceDistance(modalStore.distance)}}<span class="ml-2">{{lbl.location.km}}</span></div></h5> -->
                            <hr>
                            <div class="item">
                                <h6>{{lbl.location.address}}</h6>
                                <p v-html="modalStore.address"></p>
                            </div>
                            <hr>
                            <div class="item">
                                <h6>{{lbl.location.operation}}</h6>
                                <p v-html="modalStore.operation"></p>
                            </div>
                            <hr>
                            <div class="item">
                                <h6>{{lbl.location.phone}}</h6>
                                <p v-html="modalStore.phoneNumber"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>

<script>
import Vue from "vue";
import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js';

export default {
    name: "StoreLocationModal",
    props: {
        view: String,
        busModal: Object,
    },
    data: function() {
        return {

            bzbConfig: Vue.bzbsConfig,
            lbl: Locale.getLbl(),
            modalStore: {
                id: 'modal-',
                title: '',
                address: '',
                operation: '',
                phoneNumber: '',
            },
        };
    },
    created: function() {
        this.modalStore.id += this.view;
    },
    mounted: function() {
        this.busModal.$on('showStoreModal', this.showModalStore);
        this.busModal.$on('hideStoreModal', this.hideModalStore);
    },
    methods: {

        showModalStore: function(config) {
            this.modalStore.image_url = null
            this.modalStore.title = config.title;
            this.modalStore.address = config.address;
            this.modalStore.operation = Util.newLineToBr(config.operation);
            this.modalStore.phoneNumber = config.phoneNumber;
            this.modalStore.distance = config.distance;
            this.modalStore.image_url = config.image_url;

            this.$bvModal.show(this.modalStore.id);
        },
        hideModalStore: function() {
            this.$bvModal.hide(this.modalStore.id);
        },
        getBranceDistance: function (distance) {
            console.log("modalstore");
                return (distance/1000).toFixed(1);
        },
        getImageDefault: function() {
            var imgPath = `${this.bzbConfig.bzbsBlobUrl}/webconfig/dior/image/image-default.png`;
            return imgPath;
        }
    },
}
</script>
<style lang="scss">
@import "@/style/base/component/modal/modal.scss";
.store-img-wrapper {

    position: relative;
    width: 100%; /* desired width */
    img {
        width: 83.333%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
    }
    &:before {
        content: "";
        display: block;
        // padding-top: 66.66%; /* initial ratio of 1:1*/
        padding-top: 66.66%;
    }
}
</style>
